import { Path } from '@/main/router/routerPath';

import { Barva } from './barva';
import { HodinoveSazby } from './hodinoveSazby';
import { Interier } from './interier';
import { InterniDruh } from './internidruh';
import { KategorieZarizeni } from './kategorieZarizeni';
import { LakDruh } from './lakDruh';
import { OdhadyPracnosti } from './odhadyPracnosti';
import { OdhadyPracnostiPodil } from './odhadyPracnostiPodil';
import { OdlozenaServisniCinnost } from './odlozenaServisniCinnost';
import { OkruhPp } from './okruhPp';
import { PpDruh } from './ppDruh';
import { PpServiceNr } from './ppServiceNr';
import { PracovniPozice } from './pracovniPozice';
import { TabulkovaPozice } from './tabulkovaPozice';
import { Typ } from './typ';
import { WCas } from './wCas';
import { ZakazkaKorekceTempl } from './zakazkaKorekceTempl';
import { ZarazeniZakazky } from './zarazeniZakazky';
import { Zarizeni } from './zarizeni';
import { ServisniPakety } from './servisniPakety';
import { VolitelnyMaterialSp } from './volitelnyMaterialSP';
import { IndividualniNahradyND } from './individualniNahradyND';
import { VybavaVozidla } from './vybavaVozidla';
import { DruhSP } from './druhSP';
import { ZvlastniNabidky } from './zvlastniNabidky';
import { DruhPozadavku } from './druhPozadavku';

export const router = new Path('Dilenske').addChildren([
	Barva.router,
	HodinoveSazby.router,
	Interier.router,
	InterniDruh.router,
	KategorieZarizeni.router,
	LakDruh.router,
	OdhadyPracnosti.router,
	OdhadyPracnostiPodil.router,
	OdlozenaServisniCinnost.router,
	OkruhPp.router,
	PpDruh.router,
	PpServiceNr.router,
	PracovniPozice.router,
	ServisniPakety.router,
	TabulkovaPozice.router,
	Typ.router,
	WCas.router,
	ZakazkaKorekceTempl.router,
	ZarazeniZakazky.router,
	Zarizeni.router,
	VolitelnyMaterialSp.router,
	IndividualniNahradyND.router,
	VybavaVozidla.router,
	DruhSP.router,
	ZvlastniNabidky.router,
	DruhPozadavku.router,
]);
